import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, CircularProgress, Grid, Link } from '@material-ui/core';
import { LinkOff as LinkOffIcon } from '@material-ui/icons';
import { FHEContainerForm, FHEContainerScroll, FHEItemText, ProductTitle, FHEButton } from 'data/components';
import { Toastr, Logger } from 'data/common';
import { dissociateProduct, driveElecOlimexMigration } from '../../../../../../data/Products/actions';
import selectors from '../../../../../Home/selectors';


class DriveElecBasicForm extends PureComponent {
    static propTypes = {
        driveElecOlimexMigration: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        identifier: PropTypes.string,
        homeId: PropTypes.number,
        homeLabel: PropTypes.string,
        type: PropTypes.string,
        label: PropTypes.string,
        version: PropTypes.string,
        status: PropTypes.string,
        state: PropTypes.string,
        children: PropTypes.object,
        addressIp: PropTypes.string,
        refreshStatusProduct: PropTypes.func,
        classes: PropTypes.object.isRequired,
        dissociateProduct: PropTypes.func.isRequired,
        homeBoxMac: PropTypes.string,
        middleware: PropTypes.string,
    };

    static defaultProps = {
        identifier: null,
        homeId: null,
        homeLabel: null,
        type: null,
        label: null,
        version: null,
        status: null,
        state: null,
        children: null,
        addressIp: null,
        refreshStatusProduct: null,
        homeBoxMac: null,
        middleware: null
    };

    constructor(props) {
        super(props);
        this.state = {
            deleteLoading: false
        };
    }

    componentDidMount() {
        const { profile, history } = this.props;
        const userRight = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('products_drive_elec_details');
        if (!userRight) {
            Logger.verbose('Redirect to 403');
            return history.replace('/error/403');
        }
    }

    dissociateProduct = () => {
        const { homeId, identifier, dissociateProduct, history, type } = this.props;

        return dissociateProduct('state', homeId, identifier, 'drive_elec', 'dissociated', type)
            .then(() => {
                Toastr.success(Translator.translate('generic.products.table.action.dissociate.success'));
                return history.goBack();
            })
            .catch(err => {
                this.setState({ deleteLoading: false });
                Toastr.error(Translator.translate('generic.products.table.action.dissociate.error'), err);
            });
    };

    refreshStatusProduct = () => {
        const { identifier, refreshStatusProduct } = this.props;
        return refreshStatusProduct('drive_elec', identifier);
    };

    navigateToHomeDetail = () => {
        const { homeId, history } = this.props;
        return history.push({
            pathname: `/fhe/home/detail/${homeId}`
        });
    };

    driveElecMigration = () => {
        const { driveElecOlimexMigration, identifier, middleware, homeBoxMac } = this.props;
        //this.handleLoading(true);
        return driveElecOlimexMigration(middleware, homeBoxMac, identifier)
            .then(() => {
                Toastr.success(Translator.translate('driveElec.migrationSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('driveElec.migrationError')
                );
            })
            .finally(() => {
                //this.handleLoading(false);
            });
    };

    render() {
        const { classes, identifier, homeId, homeLabel, type, label, version, status, state, children, addressIp, profile } = this.props;
        const { deleteLoading } = this.state;
        const userRightDissociate = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`products_${type}_dissociate`);
        const userRightRefreshStatus = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`products_${type}_refreshStatus`);
        const userRightHomeDetails = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('homeDetails');

        return (
            <Fragment>
                <ProductTitle homeLabel={homeLabel} type={type} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.identifier')}
                                    itemContent={identifier ? identifier.match(/.{1,2}/g).join(':') : 'N/A'}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.showDetail')}
                                    itemTitle={Translator.translate('general.table.column.homeLabel')}
                                    itemContent={
                                        userRightHomeDetails ? (
                                            <Link component="button" onClick={this.navigateToHomeDetail}>
                                                {`#${homeId} ${homeLabel}`}
                                            </Link>
                                        ) : (
                                            `#${homeId} ${homeLabel}`
                                        )
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.type')} itemContent={type} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.label')} itemContent={label} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.version')} itemContent={version} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('generic.products.table.action.refresh.tooltip')}
                                    onClick={userRightRefreshStatus ? this.refreshStatusProduct : null}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${status}`)}
                                    classContent={status === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.status')}
                                    itemContent={Translator.translate(`general.${state}`)}
                                    classContent={state === 'dissociated' ? classes.disconnectedColor : classes.connectedColor}
                                    iconButton={
                                        userRightDissociate ? (
                                            !deleteLoading ? (
                                                <LinkOffIcon
                                                    onClick={() => {
                                                        this.setState({ deleteLoading: true });
                                                        Toastr.confirm(
                                                            Translator.translate('generic.products.table.action.dissociate.confirmRemove'),
                                                            Translator.translate('generic.products.table.action.dissociate.confirmRemoveTitle'),
                                                            {
                                                                onYes: () => {
                                                                    this.dissociateProduct().catch(() => {
                                                                        this.setState({ deleteLoading: false });
                                                                    });
                                                                },
                                                                onNo: () => {
                                                                    this.setState({ deleteLoading: false });
                                                                }
                                                            }
                                                        );
                                                    }}
                                                />
                                            ) : (
                                                <CircularProgress size={25} color="inherit" />
                                            )
                                        ) : null
                                    }
                                    iconButtonTooltip={Translator.translate('generic.products.table.action.dissociate.tooltip')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.addressIp')} itemContent={addressIp} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEButton
                                    content={Translator.translate(`driveElec.migration`)}
                                    clickFunction={this.driveElecMigration}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {children}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const productKey = props.productKey;
    const product = state.environments.fhe.data.Products.getIn(['list', productKey], new Map());
    const homes = state.environments.fhe.data.Homes.get('list');
    const boxe = selectors.getBoxByHomeId(state, product.get('homeId'));
    return {
        profile: state.data.user,
        identifier: product.get('identifier'),
        homeId: product.get('homeId'),
        homeLabel: homes.getIn([product.get('homeId').toString(), 'label'], ''),
        type: product.get('type'),
        label: product.get('label'),
        version: product.get('version'),
        status: product.get('status'),
        state: product.get('state'),
        addressIp: product.get('addressIp'),
        homeBoxMac: boxe.getIn(['macAddress'], null),
        middleware: boxe.getIn(['middleware'], null)
    };
}

const styles = theme => ({
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ dissociateProduct, driveElecOlimexMigration }, dispatch)
    )(withStyles(styles, { withTheme: true })(DriveElecBasicForm))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/DriveElec/BasicForm/index.js